import { CompanyDockageEntity } from "domain/entity/Company/CompanyDockageEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import companyAxiosInstance from "../axios/companyAxiosInstance";
import { CompanyDockageRepository } from "./CompanyDockageRepo";

export const CompanyDockageRepoImpl = (): CompanyDockageRepository => {
    const url = '/v1/companyDockage';

    const searchCompDockage = async (companyId: number): Promise<CompanyDockageEntity[]> => {
        const newUrl = url + '/';
        const result = axiosGetData(companyAxiosInstance, `${newUrl}` + companyId).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            let errorMessage = "Update Company Failure"
            if (err && err.response && err.response.data && typeof (err.response.data) === "string") {
                if (err.response.data.includes("already exist")) {

                }
            }
            throw new Error(errorMessage);
        });
        return result;
    }

    const addCompDockage = async (newData: CompanyDockageEntity): Promise<Boolean> => {
        const newUrl = url + '/add';
        const result = axiosPostData(companyAxiosInstance, `${newUrl}`, newData).then(res => {
            if (res.msg === "OK") {
                return res.data;
            } else {
                let errorMessage = "Failed to add company Dockage."
                if (res.data && typeof (res.data) === "string") {
                    if (res.data.includes("Entity Already Exists.")) {
                        errorMessage = `Duplicate record found, please check the key:Company ID,Tier.`
                    }
                }
                return "Error:" + errorMessage;
            }
        }).catch(err => {
            let errorMessage = "Failed to add company Dockage."
            throw new Error(errorMessage);
        });
        return result;
    }

    const deleteCompDockage = async (compDockageIds: number[]): Promise<Boolean> => {
        const newUrl = url + '/delete';
        const result = axiosPostData(companyAxiosInstance, `${newUrl}`, compDockageIds).then(res => {
            const data = res.data;
            return data
        }).catch(error => {
            return null
        })
        return result
    }

    return {
        searchCompDockage: searchCompDockage,
        addCompDockage: addCompDockage,
        deleteCompDockage: deleteCompDockage
    }
}